import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  SkipSelf,
  ViewChildren,
} from '@angular/core';
import {
  ControlContainer,
  AbstractControl,
  FormGroup,
  FormArray,
  FormBuilder,
  Validators,
  FormGroupDirective,
} from '@angular/forms';
import { PhoneType } from 'src/app/shared/models/arrangement';
import { ModalService } from 'src/app/shared/services/modal.service';
import { phoneTypesFormValue } from '../../form-values';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import { UniqueId } from 'src/app/shared/uniqueId';
import { changeDetection } from 'src/app/shared/change-detection';
import { Arrangement } from 'src/app/shared/classes/arrangement';

@Component({
  selector: 'app-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]],
    },
  ],
})
export class PhoneComponent implements OnInit, AfterViewInit {
  @Input() controlName!: string;

  @ViewChildren('phoneInput') phoneInputs!: QueryList<ElementRef>;

  options = phoneTypesFormValue;

  formRoot!: AbstractControl;
  formGroup!: FormArray;

  constructor(
    private controlContainer: ControlContainer,
    private formBuilder: FormBuilder,
    private modalService: ModalService
  ) {}

  ngOnInit(): void {
    const control = this.controlContainer.control?.get(this.controlName) as FormArray;

    if (control) {
      this.formGroup = control;
      this.formRoot = this.formGroup.root;

      if (!this.formGroup.length) {
        this.add();
      }
    }
  }

  ngAfterViewInit(): void {
    this.phoneInputs.changes.subscribe((phoneInputs: QueryList<ElementRef>) => {
      (phoneInputs.last.nativeElement as HTMLInputElement).focus();
    });
  }

  add() {
    const uniqueId = new UniqueId();

    let type = PhoneType.Other;

    if (this.formGroup.length === 0) {
      type = PhoneType.Primary;
    } else if (this.formGroup.length === 1) {
      type = PhoneType.Secondary;
    }

    const typeIndex = _.findIndex(phoneTypesFormValue, (phoneType) => phoneType.value === type);

    const phone = this.formBuilder.group({
      _meta: this.formBuilder.group({
        id: [uniqueId.getUniqueInArray(this.formGroup.value, '_meta.id', 'id-')],
        index: [this.formGroup.length],
      }),
      phone: [''],
      type: [phoneTypesFormValue[typeIndex]],
    });

    this.formGroup.push(phone);

    const arrangement = this.formRoot.get('_arrangement')?.value as Arrangement;

    if (arrangement) {
      arrangement.processMissingValidators();
    }
  }

  remove(index: number) {
    if (this.formGroup.length <= 1) {
      return;
    } else {
      const modal = this.modalService.generic({
        title: 'Confirm',
        copy: ['Are you sure you want to remove this email?'],
        buttons: [
          { label: 'Cancel', key: 'cancel', class: 'p-button-default' },
          { label: 'Confirm', key: 'confirm', class: 'p-button-danger', icon: 'pi-trash' },
        ],
      });

      modal.onClose.subscribe({
        next: (key) => {
          if (key === 'confirm') {
            this.formGroup.removeAt(index);
          }
        },
      });
    }
  }
}
